module.exports = __webpack_public_path__ + "img/fig32.acc13d3c.jpg";